<template>
  <header>
    <div class="container-fluid top-menu">
      <div class="container h-100">
        <div class="row h-100">
          <div class="col-xl-3 col-lg-4 col-sm-8 h-100 header-logo-container">
            <router-link to="/" class="logo-text align-self-center h-100">
              <img src="@/assets/images/logo.png" alt="KD Roofing" class="header-logo" />
            </router-link>
          </div>
          <MobileMenu></MobileMenu>
          <div class="col-xl-9 navigation">
            <ul
              class="header-nav-items menu h-100 d-flex justify-content-between align-items-center"
            >
              <li>
                <router-link class="header-nav-link" to="/about/">About</router-link>
              </li>
              <li>
                <router-link class="header-nav-link" to="/services/">Services</router-link>
              </li>
              <li>
                <router-link class="header-nav-link" to="/gallery/">Gallery</router-link>
              </li>
              <li>
                <router-link class="header-nav-link" to="/contact/">Contact</router-link>
              </li>
              <li>
                <a href="tel:07912877887" class="header-nav-link">
                  <span class="phone-icon icon-phone"></span>
                  <span class="phone-number">07912 877887</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import MobileMenu from "@/components/partials/MobileMenu";
export default {
  name: "main-header",
  components: {
    MobileMenu,
  },
};
</script>
<style lang="scss">
// Styles whitelisted from purge css
$primary-colour-one: #b11f24;

#sideNav.bm-menu {
  background-color: $primary-colour-one;
}

header .header-nav-items a.router-link-exact-active {
  border-bottom: solid 2px $primary-colour-one;
}

#sideNav a.router-link-exact-active > span {
  color: $primary-colour-one;
}

.bm-burger-bars {
  background-color: $primary-colour-one;
}

#testimonials .swiper-wrapper {
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/MainHeader.vue